import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import Error from './components/error';
import reportWebVitals from './reportWebVitals';
// import {
//   createBrowserRouter,
//   RouterProvider
// } from 'react-router-dom';
// import Base64 from './components/Base64/Base64';
// // import about from './components/About/about';

// const router = createBrowserRouter([
//   {
//     path: "/",

//     element: <App />,
//     errorElement: <Error/>,
//     children: [
//       {
//         path: "/base64",
//         element: <Base64/>,
//       },
//     ],
//   },
// ]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {/* <RouterProvider router={router}/> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
